module.exports = __webpack_public_path__ + "img/user__2_.5405d77c.png";